import { Typography } from "@mui/material";
import { LandingPageSection } from "../static-page-components/landing-page-section";
import { TestimonialCarousel } from "./testimonial-carousel";
import { Testimonial } from "./testimonial-card";

const testimonials: Testimonial[] = [
  {
    quote:
      "One of the greatest things that my designer talked me into was really utilizing some space for myself. I work and have my entire life. I had a desk crammed into a tiny guest room, and it was not really practical, so I really needed some more space. I think one of the greatest things about having a designer is that they can envision things that you cannot. You know, I really couldn't ever imagine not working with a designer now that I've had one.",
    name: "Shea W.",
    designation: "Atlanta, GA",
  },
  {
    quote:
      "Our designer put together a home that's comfortable for our family, something we have pride in to share with your friends. It's a gift.",
    name: "Jesse S.",
    designation: "Atlanta, GA",
  },
  {
    quote:
      "My designer reassured me through the whole process and had done this many times in the past. She knew step by step what our priorities were and what we needed to accomplish. She made the process seamless and very smooth.",
    name: "Leigh H.",
    designation: "Atlanta, GA",
  },
  {
    quote:
      "Home Design Guild is a very good service to use. They're a filtering service of designers in your area. They look at the overall marketplace and filter the thousands of designers down to a curated selection for you. From there, you can pick a designer that you feel comfortable with.",
    name: "Lance B.",
    designation: "Atlanta, GA",
  },
  {
    quote:
      "You need to have that friendship, that relationship. My designer knows how she can push me and not push me. She knows what my husband likes and doesn't like, and my children. But it is a business, and you have to sometimes separate business from personal relationships. But your end product will be so much better if you have a good personal relationship with your designer, because they can understand how you operate as a family and what makes you feel comfortable in your home.",
    name: "Jessie S.",
    designation: "Atlanta, GA",
  },
];

export const TestimonialSection = () => {
  return (
    <LandingPageSection className="testimonial-section" sx={{ py: {xs:8,md:'108px'}, backgroundColor: "#EEEAE7" }}>
      <Typography variant={"display2" as any} component="h2" className="text-center text-pink" sx={{ mb: "16px",letterSpacing: 0.345, lineHeight: "40px" }} fontWeight={700}>
        A PERFECT MATCH, FIND YOURS.
      </Typography>
      <Typography variant="body1" className="text-center font-size-3 contain-text" sx={{ mb: "32px" ,fontSize:{xs:"20px",md:"25px"} }}>
        If it worked for them, it could work for you.
      </Typography>
      <TestimonialCarousel testimonials={testimonials} />
    </LandingPageSection>
  );
}; 
